import Tabs from '@components/ui/tabs';
import { ArrowBack } from '@mui/icons-material';
import { Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import Faq from './faq';
import Instructions from './instructions';

export default function Information() {
  const navigate = useNavigate();
  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      sx={{ padding: '1em' }}>
      <Typography
        variant="body1"
        sx={{
          cursor: 'pointer',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
          width: 'fit-content',
          margin: '0.5em',
          marginRight: 'auto'
        }}
        onClick={() => {
          navigate(`/${window.location.search}`);
        }}>
        <ArrowBack />
        &nbsp; <strong> Back</strong>
      </Typography>
      <Tabs
        tabHeaders={
          !import.meta.env.VITE_NSDC_PARTNER
            ? ['Instructions', 'FAQs']
            : (['Instructions'] as string[])
        }
        tabsContent={[<Instructions />, !import.meta.env.VITE_NSDC_PARTNER ? <Faq /> : null]}
      />
    </Grid>
  );
}
